var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnArrowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 23.8273,
    rx: 24,
    ry: 23.8273,
    fill: "#C795DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2885_6509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1088 15.8788V15.867C38.0139 15.6483 37.8418 15.4769 37.6222 15.3824H37.6103C37.5094 15.341 37.4026 15.3174 37.2839 15.3174H29.2716C28.779 15.3174 28.3813 15.7133 28.3813 16.2038C28.3813 16.6943 28.779 17.0903 29.2716 17.0903H35.1354L27.2299 24.9618C26.8916 25.2986 26.31 25.2986 25.9717 24.9618L22.2564 21.2624C21.2118 20.2282 19.5203 20.2223 18.4758 21.2624L9.94713 29.7603C9.59697 30.109 9.59697 30.6704 9.94713 31.0132C10.1193 31.1845 10.3507 31.2732 10.5762 31.2732C10.8018 31.2732 11.0332 31.1845 11.2054 31.0132L19.7399 22.5152C20.0842 22.1666 20.6539 22.1725 20.9982 22.5152L24.7135 26.2146C25.218 26.7169 25.8886 26.9947 26.6008 26.9947C27.313 26.9947 27.9837 26.7169 28.4882 26.2146L36.3936 18.3431V24.1817C36.3936 24.6722 36.7913 25.0682 37.2839 25.0682C37.7765 25.0682 38.1741 24.6722 38.1741 24.1817V16.2038C38.1741 16.0915 38.1504 15.9793 38.1088 15.8788Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2885_6509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4881,
    height: 15.9558,
    fill: "white",
    transform: "translate(9.68597 15.3174)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnArrowPurple);
export default __webpack_public_path__ + "static/media/earn-arrow-purple.bdaefd875eeaa89e3d87130db044f100.svg";
export { ForwardRef as ReactComponent };